module.exports = {"371103001":"岚山头街道","371103002":"安东卫街道","371103100":"碑廓镇","371103101":"虎山镇","371103102":"巨峰镇","371103103":"高兴镇","371103105":"黄墩镇","371103108":"中楼镇","371103200":"前三岛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371103.json
// module id = 1336
// module chunks = 0